export async function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
export const cancelableSleep = (ms, signal) => {
    return new Promise((resolve) => {
        if (signal?.aborted) {
            resolve(false);
            return;
        }
        const timeoutId = setTimeout(() => resolve(true), ms);
        signal?.addEventListener('abort', () => {
            clearTimeout(timeoutId);
            resolve(false);
        });
    });
};
